import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams, useLocation } from "react-router";

import type { SelectOption } from "../../../commonTypes/billOfMaterial";
import type { GetAllBussinessAddressesListPayloadType } from "../../../commonTypes/clientSettingsTypes";
import type { BomDataListPayloadType } from "../../../commonTypes/invoiceGenerationTypes";
import BOMSavedTemplateTable from "../../../components/ClientSettings/BOMSavedTemplate/BOMSavedTemplateTable/BOMSavedTemplateTable";
import FullPageModal from "../../../components/ClientSettings/BOMSavedTemplate/BOMTemplateFullPageModal";
import { SearchIcon } from "../../../components/Icon";
import Filter from "../../../components/InvoiceGeneration/BillOfMaterial/BillOfMaterialFilter/Filter";
import BOMSorting from "../../../components/InvoiceGeneration/BillOfMaterial/BillOfMaterialSorting/Sorting";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { BOM_SAVED_TEMPLATE_HEADER } from "../../../constant/tableHeadersConstants/clientSettingsconstants/bomSavedTemplateHeader";
import useDebounce from "../../../customHooks/useDebounce";
import { resetSession } from "../../../redux/auth";
import {
  getAllBusinessAddressAction,
  resetBusinessAddressList,
  resetMultipleStockItemQuantityData,
} from "../../../redux/clientSettings";
import type { BusinessAddressListType } from "../../../redux/clientSettings/clientSettingTypes";
import {
  getBOMSavedTemplateListAction,
  resetBomSavedTemplateListData,
  resetInvoiceGenerationError,
  resetInvoiceGenerationSuccess,
  resetSingleBomData,
} from "../../../redux/invoiceGeneration";
import type { BomDataItemType } from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import type { RootState } from "../../../redux/rootReducers";

type AppProps = {
  history?: any;
  token?: string | null;
  client_code?: number;
  company_name?: string;
  type: string;
  fetching?: boolean;
  branchFetching?: boolean;
  success?: number | null;
  error?: string | null;
  statusCode?: number | null;
  message?: string | null;
  scrollRef?: any;
  bomSavedTemplateListData?: {
    total_count?: string | undefined;
    data?: BomDataItemType[] | [] | undefined;
  };
  businessAddressList: [] | BusinessAddressListType[];
  dispatchResetSession?: () => void;
  handleUseTemplateId: (id: number) => void;
  dispatchResetInvoiceGenerationSuccess?: () => void;
  dispatchResetMultipleStockItemData?: () => void;
  dispatchResetError?: () => void;
  dispatchResetBomSingleDataAction?: () => void;
  dispatchResetBomSavedTemplateListData?: () => void;
  dispatchResetBusinessAddressList?: () => void;
  dispatchGetBOMSavedTemplateListAction?: (
    data: BomDataListPayloadType
  ) => void;
  dispatchGetAllBusinessAddressList?: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
};

const BOMSavedTemplate = ({
  history,
  token,
  type,
  fetching,
  success,
  error,
  message,
  statusCode,
  scrollRef,
  branchFetching,
  businessAddressList,
  dispatchResetSession,
  dispatchResetError,
  bomSavedTemplateListData,
  handleUseTemplateId,
  dispatchGetBOMSavedTemplateListAction,
  dispatchResetBomSavedTemplateListData,
  dispatchResetMultipleStockItemData,
  dispatchResetBomSingleDataAction,
  dispatchResetInvoiceGenerationSuccess,
  dispatchGetAllBusinessAddressList,
  dispatchResetBusinessAddressList,
}: AppProps) => {
  const location = useLocation();
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [isApiCall, setIsApiCall] = useState<boolean>(false);
  const [viewTemplate, setViewTemplate] = useState<boolean>(false);
  const [searchData, setSearchData] = useState<string>("");
  const [templateId, setTemplateId] = useState<string>("");
  const [templateName, setTemplateName] = useState<string>("");
  const [data, setData] = useState<BomDataItemType[] | []>([]);
  const [branchList, setSetBranchList] = useState<SelectOption[] | []>([]);
  const [selectedBranch, setSelectedBranch] = useState<any>({
    label: "Select..",
    value: "",
  });
  const [branchText, setBranchText] = useState<string>("");
  const company_name =
    location && location.state && location.state.company_name
      ? location.state.company_name
      : "";
  const { id }: any = useParams();
  const client_code =
    location && location.state && location.state.client_code
      ? location.state.client_code
      : id?.includes("?")
        ? id?.split("?")[0]
        : id;
  const [sortingData, setSortingData] = useState<string>("");
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatchResetBomSavedTemplateListData?.();
    dispatchResetBomSingleDataAction?.();
    dispatchResetMultipleStockItemData?.();
    dispatchResetError?.();
    dispatchResetInvoiceGenerationSuccess?.();
    dispatchResetBusinessAddressList?.();
    if (token && client_code) {
      const finalData = {
        token,
        client_code,
      };
      dispatchGetAllBusinessAddressList?.(finalData);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    const branchOption: SelectOption[] = businessAddressList?.map(
      (item: BusinessAddressListType) => {
        return {
          label: item?.trade_name,
          value: item?.ledger_id?.toString(),
        };
      }
    );
    setSetBranchList([...branchOption]);
  }, [businessAddressList]);

  useEffect(() => {
    if (
      bomSavedTemplateListData?.data &&
      Object.keys(bomSavedTemplateListData)?.length > 0
    ) {
      if (bomSavedTemplateListData?.data?.length === 0) {
        setData([...bomSavedTemplateListData?.data]);
      }
      if (offset === 0 && bomSavedTemplateListData) {
        if (bomSavedTemplateListData?.data?.length) {
          setData([...bomSavedTemplateListData?.data]);
        }
      } else if (
        offset > 0 &&
        bomSavedTemplateListData?.data !== undefined &&
        bomSavedTemplateListData.data.length > 0
      ) {
        setData((prevData: any) => {
          if (bomSavedTemplateListData?.data) {
            return [...prevData, ...bomSavedTemplateListData.data];
          } else {
            return prevData;
          }
        });
      } else {
        setData([...bomSavedTemplateListData?.data]);
      }
    }
    //eslint-disable-next-line
  }, [bomSavedTemplateListData?.data]);

  useEffect(() => {
    if (token && client_code) {
      let splitedSortingData = sortingData?.split("#$#");

      let finalData = {
        clientCode: client_code,
        token,
        searchTerm: searchData,
        limit,
        offset,
        sortBy: splitedSortingData[0],
        sortByValue: splitedSortingData[1],
        branchId: applyFilter ? selectedBranch?.value : "",
      };
      if (
        bomSavedTemplateListData &&
        bomSavedTemplateListData["total_count"] !== undefined
      ) {
        if (offset < +bomSavedTemplateListData?.total_count) {
          dispatchGetBOMSavedTemplateListAction?.(finalData);
          setIsApiCall(true);
        } else if (
          (bomSavedTemplateListData?.total_count === undefined ||
            +bomSavedTemplateListData?.total_count === 0 ||
            bomSavedTemplateListData?.total_count === "") &&
          offset === 0
        ) {
          dispatchGetBOMSavedTemplateListAction?.(finalData);
          setIsApiCall(true);
        }
      }
    }
    //eslint-disable-next-line
  }, [offset]);

  useEffect(() => {
    if (isApiCall && token && client_code) {
      let splitedSortingData = sortingData?.split("#$#");
      let finalData = {
        clientCode: client_code,
        token,
        searchTerm: searchData,
        limit,
        offset,
        sortBy: splitedSortingData[0],
        sortByValue: splitedSortingData[1],
        branchId: applyFilter ? selectedBranch?.value : "",
      };
      dispatchGetBOMSavedTemplateListAction?.(finalData);
    }
    //eslint-disable-next-line
  }, [sortingData]);

  useEffect(() => {
    if (type == "BOMtemplate" && scrollRef) {
      const scrollElement = scrollRef?.current;
      if (scrollElement) {
        scrollElement.addEventListener("scroll", handleScroll);
      }
      return () => {
        if (scrollElement) {
          scrollElement.removeEventListener("scroll", handleScroll);
        }
      };
    } else {
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }
  }, [bomSavedTemplateListData?.data]);

  const onScroll = () => {
    // if(!fetching){
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (
      bomSavedTemplateListData &&
      bomSavedTemplateListData["total_count"] !== undefined &&
      bomSavedTemplateListData["data"] !== undefined
    ) {
      if (
        offset < +bomSavedTemplateListData?.total_count &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (bomSavedTemplateListData?.data?.length > 0) {
          if (!fetching && offset < +bomSavedTemplateListData?.total_count) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  const handleScroll = () => {
    const scrollTop = scrollRef.current.scrollTop;
    const scrollHeight = scrollRef.current.scrollHeight;
    const clientHeight = scrollRef.current.clientHeight;
    if (Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight) {
      if (
        bomSavedTemplateListData?.data &&
        bomSavedTemplateListData?.data?.length > 0
      ) {
        setOffset(offset + limit);
      }
    }
  };

  const fetchNewData = (searchValue: string) => {
    setOffset(0);
    let splitedSortingData = sortingData?.split("#$#");
    if (token) {
      let finalData = {
        clientCode: client_code,
        token,
        searchTerm: searchValue,
        limit,
        offset: 0,
        sortBy: splitedSortingData[0],
        sortByValue: splitedSortingData[1],
        branchId: applyFilter ? selectedBranch?.value : "",
      };
      dispatchGetBOMSavedTemplateListAction?.(finalData);
    }
  };

  useDebounce(
    () => {
      if (searchData) {
        fetchNewData(searchData);
      } else {
        if (isApiCall) {
          let splitedSortingData = sortingData?.split("#$#");
          setOffset(0);
          if (token) {
            let finalData = {
              clientCode: client_code,
              token,
              searchTerm: "",
              limit,
              offset: 0,
              sortBy: splitedSortingData[0],
              sortByValue: splitedSortingData[1],
              branchId: applyFilter ? selectedBranch?.value : "",
            };
            dispatchGetBOMSavedTemplateListAction?.(finalData);
          }
        }
      }
    },
    500,
    [searchData]
  );

  useDebounce(
    () => {
      if (branchText) {
        dispatchResetBusinessAddressList?.();
        if (token && client_code) {
          const finalData = {
            token,
            client_code,
            search_term: branchText,
          };
          dispatchGetAllBusinessAddressList?.(finalData);
        }
      } else {
        dispatchResetBusinessAddressList?.();
        if (token && client_code) {
          const finalData = {
            token,
            client_code,
            search_term: "",
          };
          dispatchGetAllBusinessAddressList?.(finalData);
        }
      }
    },
    500,
    [branchText]
  );

  useEffect(() => {
    if (applyFilter) {
    } else {
      if (token && client_code) {
        setOffset(0);
        let splitedSortingData = sortingData?.split("#$#");
        let finalData = {
          clientCode: client_code,
          token,
          searchTerm: searchData,
          limit,
          offset: 0,
          sortBy: splitedSortingData[0],
          sortByValue: splitedSortingData[1],
          branchId: "",
        };
        dispatchGetBOMSavedTemplateListAction?.(finalData);
      }
    }
    //eslint-disable-next-line
  }, [applyFilter]);

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);
  };
  const handleBOMSavedTemplateView = ({
    data,
    name,
  }: {
    data: any;
    name: string;
  }) => {
    dispatchResetMultipleStockItemData?.();
    dispatchResetBomSingleDataAction?.();
    setTemplateId(data?.template_id);
    setTemplateName(data?.template_name);
    if (name?.length > 0) {
      handleUseTemplateId(data?.template_id);
      setViewTemplate(false);
    } else {
      setViewTemplate(true);
    }
  };

  const handleBOMTemplateModal = () => {
    setViewTemplate(!viewTemplate);
  };

  const handleBranchChange = () => {
    setOffset(0);
    if (token && client_code && selectedBranch?.value) {
      setApplyFilter(true);
      let splitedSortingData = sortingData?.split("#$#");
      let finalData = {
        clientCode: client_code,
        token,
        searchTerm: searchData,
        limit,
        offset: 0,
        sortBy: splitedSortingData[0],
        sortByValue: splitedSortingData[1],
        branchId: selectedBranch?.value,
      };
      dispatchGetBOMSavedTemplateListAction?.(finalData);
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError?.();
            }}
          />
        );
      }
    }
  };

  return (
    <div className="row">
      {!type && (
        <div className="col-md-6 mb-3">
          <CommonHeader
            title={`Manufacturing Journal Template List`}
            company_name={company_name}
            client_code={client_code}
          />
        </div>
      )}
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header">
            <div className="left-header">
              <div className="heading"> Saved Template List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  bomSavedTemplateListData?.total_count
                    ? bomSavedTemplateListData?.total_count
                    : 0
                } entries found`}</div>
              )}
            </div>
            <div className="col-md-8 d-flex justify-content-end">
              <div className="mr-3 w-auto position-relative">
                <span
                  style={{ position: "absolute", top: "8px", left: "13px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  value={searchData}
                  placeholder="Search"
                  onChange={(e: any) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                />
              </div>
              <div className="mr-2">
                <Filter
                  branchOption={branchList}
                  setSelectedBranch={setSelectedBranch}
                  setBranchText={setBranchText}
                  selectedBranch={selectedBranch}
                  handleBranchChange={handleBranchChange}
                  applyFilter={applyFilter}
                  setApplyFilter={setApplyFilter}
                  fetching={branchFetching}
                />
              </div>
              <div className="mr-2">
                <BOMSorting
                  type="BOMtemplate"
                  setOffset={setOffset}
                  sortingData={sortingData}
                  setSortingData={setSortingData}
                />
              </div>
            </div>
          </div>
          <>
            {fetching && offset === 0 ? (
              <TableLoader
                Rows={10}
                ColumnPerRow={7}
              />
            ) : (bomSavedTemplateListData?.data?.length ?? 0 > 0) ? (
              <BOMSavedTemplateTable
                fetching={fetching}
                data={data}
                headers={BOM_SAVED_TEMPLATE_HEADER}
                offset={offset}
                handleBOMSavedTemplateView={handleBOMSavedTemplateView}
                type={type ? type : ""}
              />
            ) : (
              <div className="p-5">
                <EmptyListPage
                  title="No Template is found!"
                  company_name={company_name}
                  client_code={client_code}
                  // image={CustomerSupplier}
                  imageWidth="30%"
                />
              </div>
            )}
          </>
        </div>
      </div>
      {handleErrorModal()}
      {viewTemplate && (
        <FullPageModal
          isOpen={viewTemplate}
          templateId={templateId}
          templateName={templateName}
          handleBOMTemplateModal={handleBOMTemplateModal}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.invoiceGeneration.fetching,
  success: state.invoiceGeneration.success,
  statusCode: state.invoiceGeneration.statusCode,
  error: state.invoiceGeneration.error,
  message: state.invoiceGeneration.message,
  bomSavedTemplateListData: state.invoiceGeneration.bomSavedTemplateListData,
  businessAddressList: state.clientSettings.businessAddressList,
  branchFetching: state.clientSettings.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetError: () => dispatch(resetInvoiceGenerationError()),
  dispatchResetBomSavedTemplateListData: () =>
    dispatch(resetBomSavedTemplateListData()),
  dispatchResetInvoiceGenerationSuccess: () =>
    dispatch(resetInvoiceGenerationSuccess()),
  dispatchResetBomSingleDataAction: () => dispatch(resetSingleBomData()),
  dispatchGetBOMSavedTemplateListAction: (data: BomDataListPayloadType) =>
    dispatch(getBOMSavedTemplateListAction(data)),
  dispatchResetMultipleStockItemData: () =>
    dispatch(resetMultipleStockItemQuantityData()),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(BOMSavedTemplate);
